import { call, put, delay } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { updateRoleBegin, updateRoleFailed, updateRoleSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* updateRole(action) {
  try {
    const {
      name = '',
      display_name = '',
      id,
      users,
      permissions,
      useDelay = false,
    } = action.payload;
    const url = `${BACKEND_URL}/roles/${id}/update`;
    const pool = {
      name,
      display_name,
    };
    if (users && Array.isArray(users)) {
      pool.users = users;
    }
    if (permissions && Array.isArray(permissions)) {
      pool.permissions = permissions.map(i => i);
    }
    if (useDelay) {
      yield delay(2000);
    }
    yield put(updateRoleBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK
      && data
      && data.result
      && data.result.is_ok
    ) {
      yield put(updateRoleSuccessful([]));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(updateRoleFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(updateRoleFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
